import React from 'react';

const JS_Style_Guide = () => {
  return (
    <div >
      <h1>JS_Style_Guide</h1>
      <p>Placeholder component for: "JS Style Guide"</p>
    </div>
  );
};

export default JS_Style_Guide;
